import { Construction, Waves, Landmark, Ban, CalendarRange, CircleHelp, CheckCircle2, AlertTriangle, ShieldCheck } from "lucide-react";

export const CATEGORY_META = {
  "Road Closure": { icon: Construction, color: "#dc2626", tint: "bg-red-50 text-red-700 border-red-200" },
  Flooding: { icon: Waves, color: "#0284c7", tint: "bg-sky-50 text-sky-700 border-sky-200" },
  "Bridge Restriction": { icon: Landmark, color: "#b45309", tint: "bg-amber-50 text-amber-800 border-amber-200" },
  "Access Restriction": { icon: Ban, color: "#7c3aed", tint: "bg-violet-50 text-violet-700 border-violet-200" },
  "Planned Event": { icon: CalendarRange, color: "#059669", tint: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  Other: { icon: CircleHelp, color: "#475569", tint: "bg-slate-100 text-slate-700 border-slate-200" },
};

export const STATUS_META = {
  active: { label: "Active", icon: ShieldCheck, tint: "bg-blue-50 text-blue-700 border-blue-200", dot: "bg-blue-600" },
  needs_verification: { label: "Needs Verification", icon: AlertTriangle, tint: "bg-amber-50 text-amber-800 border-amber-300", dot: "bg-amber-500" },
  resolved: { label: "Resolved", icon: CheckCircle2, tint: "bg-slate-100 text-slate-600 border-slate-200", dot: "bg-slate-400" },
};

export const catMeta = (c) => CATEGORY_META[c] || CATEGORY_META.Other;
export const statusMeta = (s) => STATUS_META[s] || STATUS_META.active;

export const EVENT_LABEL = {
  created: "Created",
  edited: "Edited",
  update: "Update",
  verified: "Verified still active",
  resolved: "Resolved",
  reopened: "Reopened",
};
